import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { PromoBanner } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledSuccessBannerWrapper = styled(Stack)`
    width: 284px;
    justify-content: center;
    min-height: 178px;
    row-gap: 12px;
    align-items: center;
    background-color: ${rgba(colorsPalettes.carbon[0], 0.6)};
    border-radius: 8px;
    padding: 10px 12px 12px;
`;

export const SuccessContentWrapper = styled(Stack)`
    row-gap: 4px;
    margin-top: -80px;
    align-items: center;
`;

export const StyledIcon = styled(SWReactIcons)`
    width: 228px;
    height: 206px;
    margin-top: -26px;
`;

export const StyledRowSuccessPromoBanner = styled(PromoBanner)`
    padding: 8px 24px;
`;
